<template>
    <v-toolbar absolute flat color="primary" width="100%" height="70px" dark>
        <div>
            <div class="caption">{{$t('gefundeneModelleLabel')}}: <span class="font-weight-bold">{{ findNumberOfModels() }}</span></div>
            <div class="caption">{{$t('artikelnummerLabel')}}: <span class="font-weight-bold">{{ currentArticleNumber() }}</span></div>
            <!-- delete dialog confirmation -->
            <v-dialog max-width="460px" v-model="deleteDialogConfirmation">
                <v-card class="text-center no-word-break">
                    <v-card-title class="justify-center mb-4">{{ $t('deleteProductTitle') }}</v-card-title>
                    <v-card-subtitle>{{ $t('deleteProductDescription') }}</v-card-subtitle>
                    <div class="d-flex justify-center px-4 pb-4">
                        <v-btn depressed class="mx-1" @click="toggleDeleteConfirmationDialog">
                            {{ $t('deleteConfigurationReturn') }}</v-btn>
                        <v-btn depressed color="primary" class="mx-1" @click="deleteConfiguration">
                            {{ $t('deleteConfigurationConfirm') }}</v-btn>
                    </div>
                </v-card>
            </v-dialog>
        </div>
        <v-spacer></v-spacer>
        <v-btn v-if="getMainNavActiveId === 0" fab small color="white" @click="toggleDeleteConfirmationDialog">
            <v-icon color="black">mdi-trash-can-outline</v-icon>
        </v-btn>
    </v-toolbar>
</template>
<script>
    import Vue from 'vue';
    import * as $ from 'jquery';
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';
    import {
        modelSelectionNavigationItemsInit,
        NavigationFilter
    } from "../../../configurator/ModelSelectionNavigationItems";
    import {DoorConfiguration} from "../../../configurator/DoorConfiguration";
    import {MainNavigationFilter, mainNavigationItems} from "../../../configurator/MainNavigation";
    export default Vue.extend({
       name: 'ModelsFound',
       data() {
           return {
               deleteDialogConfirmation: false,
               snackbar: {
                   show: true,
                   message: "",
               }
           }
       },
       computed: {
            ...mapGetters('configuratorModule',['getConfiguratorState', 'getCurrentDoorConfiguration', 'getProductId', 'getMainNavActiveId']),
            ...mapGetters('modelSelectionModule', ['getModelSelection', 'getProductMatrix']), 
            newConfiguration: function(){
                if(this.$store.state.configuratorModule.productId == 0){
                    return true
                }
                else{
                    return false
                }
            }
        },
        methods : {
            ...mapActions('configuratorModule',['setArticleNumber', 'setProductId', 'setMainNavigationItems', 'setAllInitialCharacteristicsAndValues']),
            currentArticleNumber(){
                const artickeNumer = this.$store.getters['configuratorModule/getCurrentDoorConfiguration'].GetCurrentDoorArticleNumber();         
                this.setArticleNumber(artickeNumer);
                
                return artickeNumer;
            },
            toggleDeleteConfirmationDialog(){
                this.deleteDialogConfirmation = !this.deleteDialogConfirmation
            },
            findNumberOfModels() {
                let matrixCharacteristics = this.getProductMatrix.characteristics;
                let getModelSelectionRegistered = Object.values(this.getCurrentDoorConfiguration.configuration.table).find(x => x.key === 1).value;
                let numberOfModels = 0;
                for(let i = 0; i < matrixCharacteristics.length; i++) {
                    if(!getModelSelectionRegistered.find(x => x.code === matrixCharacteristics[i].code)) {
                        numberOfModels += matrixCharacteristics[i].values.length;
                    }
                }
                // return numberOfModels === 0 ? 1 : numberOfModels;
              return this.getProductMatrix.nrModelsFound
            },
            deleteConfiguration() {
                if(this.getProductId !== 0) {
                    this.axios
                        .delete("/api/productConfiguration/delete", {
                            params: {
                                id: this.getProductId,
                            },
                        })
                        .then(() => {
                            this.deleteDialogConfirmation = false;
                            this.snackbar.message = this.$t("productDeletedLabel");
                            this.$EventBus.$emit("snackbar", this.snackbar);
                            this.setProductId(0);
                            this.initializeConfigurator(null,true)
                            this.setAllInitialCharacteristicsAndValues();
                            location.href = "/product-configurator";
                            // this.$router.push("/product-configurator");
                            // this.$router.push({ name: 'Products' })
                        })
                        .catch((error) => {
                            this.snackbar.message = this.$t("productCannotDeletedLabel");
                            this.$EventBus.$emit("snackbar", this.snackbar);
                            console.log(error);
                        });
                }
                else {
                    this.setProductId(0);
                    this.initializeConfigurator(null,true)
                    this.setAllInitialCharacteristicsAndValues();
                    location.href = "/product-configurator";
                    // this.$router.push("/product-configurator");
                }

            },
            initializeConfigurator(data, isNew){
                if(isNew)
                {
                    this.$store.dispatch('configuratorModule/deleteAllStepsConfigurations');
                    this.$store.dispatch('configuratorModule/resetState');
                    this.$store.dispatch('configuratorModule/resetMainNavigationItems');
                    this.$store.dispatch('modelSelectionModule/resetState');
                    this.$store.dispatch('functionsModule/resetState');
                    this.$store.dispatch('frameModule/resetState');
                    this.$store.dispatch('measureModule/resetState');
                    this.$store.dispatch('doorLeafSurfaceModule/resetState');
                    this.$store.dispatch('exteriorAccessoryModule/resetState');
                    this.$store.dispatch('mountingMaterialModule/resetState');
                    this.$store.dispatch('blindstockMultiplexModule/resetState');
                    this.$store.dispatch('furtherInformationModule/resetState');
                    this.$store.dispatch('storeCurrentProduct',{});

                    // reset navigation
                    this.resetModelSelectionMenu();
                    this.resetMainNavigationMenu();

                }
            },
            resetModelSelectionMenu() {
                let currentDoorConfigurator = this.$store.getters['configuratorModule/getCurrentDoorConfiguration'];
                let nav = new NavigationFilter(this.$store.getters['modelSelectionModule/getNavigationItems'])
                const filter = nav.NavigationItemsFilter(currentDoorConfigurator.Get(DoorConfiguration.ModelSelection))
                this.$store.dispatch('modelSelectionModule/setNavigationItems', filter);
            },
            resetMainNavigationMenu() {
                let objModelSelectionNavigationItemsInit = JSON.parse(JSON.stringify(modelSelectionNavigationItemsInit));
                let objMainNavigationItems = JSON.parse(JSON.stringify(mainNavigationItems));
                let mainNav = new MainNavigationFilter(objMainNavigationItems);
                let mainNavItems = mainNav.UpdateMainNavigation(objModelSelectionNavigationItemsInit, 1, false, true);
                this.setMainNavigationItems(mainNavItems);
            },
        },
    });
</script>

<style scoped>
.card-header{
    height: 90px;
    overflow: hidden;
}
</style>